/* App/Lib/GeneralHelpers.js */
import { Platform } from 'react-native';

export function getOS(): string {
  return Platform.OS;
}
